export default "__VITE_ASSET__DGH8vcZv__"